import { render } from "./Support.vue?vue&type=template&id=44bfdf24"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=44bfdf24&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__